import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e54940c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TNovoUsuario__HeaderModal" }
const _hoisted_2 = { class: "TNovoUsuario__TextoHeaderModal" }
const _hoisted_3 = { class: "TNovoUsuario__ConteudoModal" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("em", { class: "pi pi-exclamation-triangle" })
], -1))
const _hoisted_5 = { class: "TNovoUsuario__TextoMensagemModal" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { class: "TNovoUsuario__FooterModal" }

import { storeToRefs } from "pinia"
  import PButton from "primevue/button"
  import { LPadrao } from "@/layouts"
  import {
    OAtributosAlocacaoUsuario,
    OUsuarioInformacoes,
    ODadosResponsabilidadeUsuario,
    TNovoUsuario
  } from "@/components/Usuarios"
  import { MenuItem } from "primevue/menuitem"
  import { computed, ref, onMounted, onUnmounted } from "vue"
  import { useRouter } from "vue-router"
  import useVuelidate from "@vuelidate/core"
  import { usuariosStore } from "@/store/listaUsuarios"
  import UsuariosRepositorio from "@/repositorios/usuarios/usuarios.repositorio"
  import Dialog from "primevue/dialog"
  import TabMenu from "primevue/tabmenu"
  import { OTrilhaDeNavegacao, MBotoesRodape } from "@/components/Gerais"
  import { usarMensagemUsuario } from "@/composable/UsarMensagemUsuario/usarMensagemUsuario"
  import { usarEscritorDeDados } from "@/composable/UsarEscritorDeDados/usarEscritorDeDados"
  import { usarLeitorDeDados } from "@/composable/UsarLeitorDeDados/usarLeitorDeDados"
  import {
    ListarUsuarios,
    ParamsUsuario,
    CriarUsuario
  } from "@/repositorios/usuarios/usuarios.modelo"
  import { usarManipuladorObjetos } from "@/composable/UsarManipuladorObjetos/usarManipuladorObjetos"
  import { usarFoto } from "@/composable/UsarFoto/usarFoto"
  import { useI18n } from "vue-i18n"
  interface Props {
    idUsuario?: string
  }

  type DadosDoUsuarioFormulario = {
    perfilDeOrganizacao: string
    codigo: string
    nome: string
    email: string
    urlFotoAvatar: string
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'NovoUsuario',
  props: {
    idUsuario: null
  },
  setup(__props: any) {

const props = __props as {
    idUsuario?: string
  }

  

  const { t } = useI18n()

  const nome = ref<string>("")
  const codigo = ref<string>("")
  const usuariosResponsaveis = ref<string[]>([])

  const { email, senha, perfilDeOrganizacao } = storeToRefs(usuariosStore())
  const usuariosState = usuariosStore()
  const usuariosRepo = new UsuariosRepositorio()

  const { onErro, onSucesso } = usarMensagemUsuario()
  const { colher } = usarManipuladorObjetos()
  const { leitor } = usarLeitorDeDados()
  const { escritor } = usarEscritorDeDados()
  const { obterUrlFotoUsuario } = usarFoto()
  const lerUsuarios = leitor<ListarUsuarios, ParamsUsuario>(
    usuariosRepo.listarUsuarios,
    {}
  )
  const atualizarUsuario = escritor<{ id: string }, string, CriarUsuario>(
    usuariosRepo.atualizarUsuario,
    [
      "",
      {
        id: "",
        nome: nome.value,
        codigo: codigo.value,
        email: email.value,
        usuariosResponsaveis: usuariosResponsaveis.value,
        senha: "",
        perfilDeOrganizacao: perfilDeOrganizacao.value,
      },
    ]
  )
  const criarUsuario = escritor<{ id: string }, any, CriarUsuario>(
    usuariosRepo.criarUsuario,
    [
      {
        nome: nome.value,
        codigo: codigo.value,
        email: email.value,
        usuariosResponsaveis: usuariosResponsaveis.value,
        senha: "",
      },
    ]
  )

  const alterarFotoUsuario = escritor<{ id: string }, string, FormData>(
    usuariosRepo.atualizarFotoUsuario,
    []
  )

  const router = useRouter()
  const indexAtivo = ref(0)

  const escopoValidacao = "Novo_Usuario"
  const v$ = useVuelidate({ $scope: escopoValidacao })

  const display = ref(false)
  const foto = ref<File>()
  const fotoUrl = ref<string | null>()
  const atualizarFoto = (arquivo: File) => {
    foto.value = arquivo
  }
  const alertarCancelarNovoUsuario = () => {
    display.value = true
  }

  const fecharModal = () => {
    display.value = false
  }

  const home = ref<MenuItem>({
    label: t("usuarios"),
    icon: "pi pi-users",
    to: "/usuarios",
  })

  const idParametroUsuario = ref<string>(props.idUsuario as string)

  const existeIdNaRota = computed(() => {
    return Boolean(props.idUsuario)
  })

  const tituloModalCancelar = computed(() => {
    const verboDaAcao = existeIdNaRota.value ? "edição" : "adição"
    return `${t("cancelar")} ${verboDaAcao} ${t("doUsuario")}`
  })

  const submetendoUsuario = computed(() => {
    return (
      alterarFotoUsuario.resultado.status === "pendente" ||
      atualizarUsuario.resultado.status === "pendente" ||
      criarUsuario.resultado.status === "pendente"
    )
  })

  const breadCrumbItems = ref<MenuItem[]>([])

  const itensTabMenu: MenuItem[] = [
    { label: t("dadosDeAcessoResponsabilidades") },
    {
      label: t("atributosParaAlocacaoDoProfissional"),
      disabled: existeIdNaRota.value,
    },
  ]

  const definirBreadcrumb = () => {
    if (existeIdNaRota.value) {
      return [
        {
          label: `${t('editar')} ${nome.value}`,
          to: `/usuarios/editar-usuario/${props.idUsuario}`,
        },
      ]
    } else {
      return [
        {
          label: t("criarNovoUsuario"),
          to: "/usuarios/novo-usuario",
        },
      ]
    }
  }

  const editarUsuario = async (dadosUsuario: CriarUsuario) => {
    atualizarUsuario.mudarArgumentos([dadosUsuario.id, dadosUsuario])
    await atualizarUsuario.executar()

    if (atualizarUsuario.resultado.status == "sucesso") {
      if (foto.value) {
        await submeterAlterarFotoUsuario(
          foto.value,
          atualizarUsuario.resultado.dados.id
        )
      }
      onSucesso({
        resumo: t("usuarioEditado"),
        detalhes: `${t("usuario")} ${dadosUsuario.nome} + ${t("editadoComSucesso")}`,
      })
      redirecionarParaListaDeUsuarios()
    }

    if (atualizarUsuario.resultado.status == "erro") {
      onErro({
        resumo: t("erroAoTentarEditarUsuario"),
        detalhes: atualizarUsuario.resultado.mensagem,
      })
    }
  }

  const submeterAlterarFotoUsuario = async (fotoDoUsuario: File, id: string) => {
    const formData = new FormData()
    formData.append("arquivos", fotoDoUsuario)

    alterarFotoUsuario.mudarArgumentos([id, formData])
    await alterarFotoUsuario.executar()
    if (alterarFotoUsuario.resultado.status === "sucesso") {
      onSucesso({
        resumo: t("fotoAlterada"),
        detalhes: t("fotoDoUsuarioAlteradaComSucesso"),
      })
    }
    if (alterarFotoUsuario.resultado.status === "erro") {
      onErro({
        resumo: t("erroAoAlterarFoto"),
        detalhes: t("ocorreuUmErroAoAlterarFoto"),
      })
    }
  }

  const criarNovoUsuario = async (dadosUsuario: CriarUsuario) => {
    criarUsuario.mudarArgumentos([dadosUsuario])
    await criarUsuario.executar()

    if (criarUsuario.resultado.status == "sucesso") {
      if (foto.value) {
        await submeterAlterarFotoUsuario(
          foto.value,
          criarUsuario.resultado.dados.id
        )
      }

      onSucesso({
        resumo: t("usuarioCriado"),
        detalhes: `${t("usuario")} ${dadosUsuario.nome} ${t("criadoComSucesso")}`,
      })
      redirecionarParaListaDeUsuarios()
    }
    if (criarUsuario.resultado.status == "erro") {
      onErro({
        resumo: t("erroAoTentarCriarUsuario"),
        detalhes: criarUsuario.resultado.mensagem,
      })
    }
  }

  const resetarDadosDoUsuarioNaStore = () => {
    usuariosState.$reset()
  }

  const recuperarDadosDoUsuarioNaStore = (): CriarUsuario => {
    return {
      id: idParametroUsuario.value,
      ativo: true,
      codigo: codigo.value,
      email: email.value,
      nome: nome.value,
      senha: senha.value,
      perfilDeOrganizacao: perfilDeOrganizacao.value,
    }
  }

  const configurarFormularioModoEditar = async (
    dadosUsuario: DadosDoUsuarioFormulario
  ) => {
    if (dadosUsuario.urlFotoAvatar) {
      fotoUrl.value = await obterUrlFotoUsuario(dadosUsuario.urlFotoAvatar)
    }
    codigo.value = dadosUsuario.codigo
    email.value = dadosUsuario.email
    nome.value = dadosUsuario.nome
    perfilDeOrganizacao.value = dadosUsuario.perfilDeOrganizacao
  }

  const redirecionarParaListaDeUsuarios = () => {
    router.push("/usuarios")
  }

  const submeterUsuario = async () => {
    v$.value.$touch()

    const camposEstaoValidos = await v$.value.$validate()
    if (!camposEstaoValidos) {
      onErro({
        resumo: t("camposInvalidos"),
        detalhes: t("preenchaCorretamenteOsCampos"),
      })
      return
    }

    const dadosUsuario = recuperarDadosDoUsuarioNaStore()

    if (existeIdNaRota.value) {
      await editarUsuario(dadosUsuario)
    } else {
      await criarNovoUsuario(dadosUsuario)
    }
  }

  const carregarDadosNoModoEditarUsuario = async (idDoUsuario: string) => {
    lerUsuarios.sobrescreverParametros({ id: `igual.${idDoUsuario}` })

    await lerUsuarios.executar()

    if (lerUsuarios.resultado.status == "vazio") {
      onErro({
        resumo: t("erroInesperado"),
        detalhes: t("naoFoiPossivelEncontrarUsuario"),
      })
      redirecionarParaListaDeUsuarios()

      return
    }
    if (lerUsuarios.resultado.status == "sucesso") {
      const dadosParaEditarDoUsuario = colher<
        ListarUsuarios,
        DadosDoUsuarioFormulario
      >(lerUsuarios.resultado.dados, [
        "codigo",
        "nome",
        "email",
        "perfilDeOrganizacao",
        "urlFotoAvatar",
      ])

      configurarFormularioModoEditar(dadosParaEditarDoUsuario[0])
    }
  }

  onMounted(async () => {
    if (existeIdNaRota.value) {
      await carregarDadosNoModoEditarUsuario(idParametroUsuario.value)
    }

    breadCrumbItems.value = definirBreadcrumb()
  })

  onUnmounted(() => {
    resetarDadosDoUsuarioNaStore()
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(LPadrao), {
    class: "NovoUsuario",
    "data-testid": "NovoUsuario"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(TNovoUsuario), null, {
        navegacao: _withCtx(() => [
          _createVNode(_unref(OTrilhaDeNavegacao), {
            "inicio-da-trilha": home.value,
            "itens-da-trilha": breadCrumbItems.value
          }, null, 8, ["inicio-da-trilha", "itens-da-trilha"])
        ]),
        perfil: _withCtx(() => [
          _createVNode(_unref(OUsuarioInformacoes), {
            codigo: codigo.value,
            "onUpdate:codigo": _cache[0] || (_cache[0] = ($event: any) => ((codigo).value = $event)),
            fotoUrl: fotoUrl.value,
            "onUpdate:fotoUrl": _cache[1] || (_cache[1] = ($event: any) => ((fotoUrl).value = $event)),
            nome: nome.value,
            "onUpdate:nome": _cache[2] || (_cache[2] = ($event: any) => ((nome).value = $event)),
            usuariosResponsaveis: usuariosResponsaveis.value,
            "onUpdate:usuariosResponsaveis": _cache[3] || (_cache[3] = ($event: any) => ((usuariosResponsaveis).value = $event)),
            "onUpdate:foto": atualizarFoto,
            "escopo-validacao": escopoValidacao,
            responsaveis: usuariosResponsaveis.value
          }, null, 8, ["codigo", "fotoUrl", "nome", "usuariosResponsaveis", "responsaveis"])
        ]),
        tabmenu: _withCtx(() => [
          _createVNode(_unref(TabMenu), {
            activeIndex: indexAtivo.value,
            "onUpdate:activeIndex": _cache[4] || (_cache[4] = ($event: any) => ((indexAtivo).value = $event)),
            class: "NovoUsuario__TabMenu",
            model: itensTabMenu
          }, null, 8, ["activeIndex"])
        ]),
        centro: _withCtx(() => [
          _withDirectives(_createVNode(_unref(ODadosResponsabilidadeUsuario), {
            "alteracao-de-senha": _unref(existeIdNaRota),
            class: "TDadosResponsabilidadeUsuario",
            "escopo-validacao": escopoValidacao
          }, null, 8, ["alteracao-de-senha"]), [
            [_vShow, indexAtivo.value === 0]
          ]),
          _withDirectives(_createVNode(_unref(OAtributosAlocacaoUsuario), {
            class: "TAtributosAlocacaoUsuario",
            disabled: _unref(existeIdNaRota)
          }, null, 8, ["disabled"]), [
            [_vShow, indexAtivo.value === 1]
          ])
        ]),
        rodape: _withCtx(() => [
          _createVNode(_unref(MBotoesRodape), {
            onCancelar: alertarCancelarNovoUsuario,
            onSalvar: submeterUsuario,
            carregando: _unref(submetendoUsuario),
            "rotulo-botao-negar": _unref(t)('cancelar')
          }, null, 8, ["carregando", "rotulo-botao-negar"])
        ]),
        modais: _withCtx(() => [
          _createVNode(_unref(Dialog), {
            visible: display.value,
            "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((display).value = $event)),
            draggable: false,
            style: { backgroundColor: 'white' }
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(tituloModalCancelar)), 1)
              ])
            ]),
            footer: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_unref(PButton), {
                  onClick: fecharModal,
                  class: "TNovoUsuario__BotaoModalVoltar",
                  label: _unref(t)('voltarEditar')
                }, null, 8, ["label"]),
                _createVNode(_unref(PButton), {
                  onClick: redirecionarParaListaDeUsuarios,
                  class: "TNovoUsuario__BotaoModalCancelar",
                  label: _unref(t)('simCancelar')
                }, null, 8, ["label"])
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _createTextVNode(_toDisplayString(_unref(t)("aoCancelarVocePerdera")) + " ", 1),
                  _hoisted_6,
                  _createTextVNode(" " + _toDisplayString(_unref(t)("asInformacoesNaoSalvas")), 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["visible"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})